import apiClient from '../../services/api/apiClient';

export async function fetchPortalOverview(orgName) {
  const { data } = await apiClient.get('/portal/overview');
  return { ...data, orgName: data.organizationName };
}

export async function fetchPortalReports() {
  const { data } = await apiClient.get('/portal/reports');
  return data;
}

export async function fetchPortalVulnerabilities() {
  const { data } = await apiClient.get('/portal/vulnerabilities');
  return data;
}

export async function fetchPortalNotifications() {
  const { data } = await apiClient.get('/portal/notifications');
  return data;
}

export async function markPortalNotificationRead(id) {
  const { data } = await apiClient.patch(`/portal/notifications/${id}/read`);
  return data;
}

export async function downloadPortalReport(report) {
  const response = await apiClient.get(`/portal/reports/${report.id}/download`, { responseType: 'blob' });
  const url = URL.createObjectURL(response.data);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `cyberguard-report-${report.id}.json`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

export async function fetchSupportTickets() {
  // Adapter: the real backend is the same Ticket Management module the main
  // app uses (/portal/tickets -> TicketResponse), field-mapped to the
  // portal's subject/updated naming so PortalSupportPage doesn't need to
  // know about that difference.
  const { data } = await apiClient.get('/portal/tickets');
  return data.map((t) => ({ id: t.id, subject: t.title, status: String(t.status || 'OPEN').toLowerCase(), priority: t.priority, updated: t.updatedAt }));
}

export async function createSupportTicket(subject, message) {
  const { data } = await apiClient.post('/portal/tickets', { title: subject, description: message });
  return { id: data.id, subject: data.title, status: String(data.status || 'OPEN').toLowerCase(), priority: data.priority, updated: data.updatedAt };
}

export async function portalLogin(email, password) {
  const { login } = await import('../../services/api/authService');
  const result = await login(email.trim(), password);
  if (result.mfaRequired) return { ...result, email };
  return {
    ...result,
    email,
    orgName: 'Client Portal'
  };
}
